import Pin from './Pin';

export default Pin;
